export default {
  meta: {
    title: '资源微服务租户管理'
  }
};
